import MenuExample from "./examples/Menu.Example";
import SubmenuExample from "./examples/Submenu.Example";

export default [
    {
        title: "Basic menu",
        component: MenuExample,
        code: require("!raw-loader!./examples/Menu.Example.tsx")
    },
    {
        title: "Menu with sub-menu",
        component: SubmenuExample,
        code: require("!raw-loader!./examples/Submenu.Example.tsx")
    }
];
